import { defineMessages } from 'react-intl';

export function accessibilityMessage(accessibilityKey: string) {
  return {
    id: `app.inventory.accessibility.${accessibilityKey}`,
  };
}

export const messages = defineMessages({
  appCommonBack: {
    id: 'app.common.back',
  },
  appCommonNext: {
    id: 'app.common.next',
  },
  fieldWizardAccessibilityDescription: {
    id: 'app.inventory.fieldWizard.accessibility.description',
  },
  fieldWizardAccessibilityNoneSelected: {
    id: 'app.inventory.fieldWizard.accessibility.noneSelected',
  },
  fieldWizardCatalogNoOptionsMatch: {
    id: 'app.inventory.fieldWizard.catalog.noOptionsMatch',
  },
  fieldWizardOutputDescription: {
    id: 'app.inventory.fieldWizard.output.description',
  },
  fieldWizardOutputFree: {
    id: 'app.inventory.fieldWizard.output.free',
  },
  fieldWizardOutputOccupied: {
    id: 'app.inventory.fieldWizard.output.occupied',
  },
  fieldWizardOutputOccupiedDescription: {
    id: 'app.inventory.fieldWizard.output.occupiedDescription',
  },
  fieldWizardOutputRemoteReadingOwner: {
    id: 'app.inventory.fieldWizard.output.remoteReadingOwner',
  },
  fieldWizardOutputRemoteReadingOwnerPlaceholder: {
    id: 'app.inventory.fieldWizard.output.remoteReadingOwnerPlaceholder',
  },
  fieldWizardOutputTechnology: {
    id: 'app.inventory.fieldWizard.output.technology',
  },
  fieldWizardOutputUnavailableDescription: {
    id: 'app.inventory.fieldWizard.output.unavailableDescription',
  },
  fieldWizardOutputUnavailableTitle: {
    id: 'app.inventory.fieldWizard.output.unavailableTitle',
  },
  identityCommodityDescription: {
    id: 'app.inventory.identity.commodity.description',
  },
  identityCommodityTitle: {
    id: 'app.inventory.identity.commodity.title',
  },
  inventorizationActionsBackToScan: {
    id: 'app.inventory.inventorization.actions.backToScan',
  },
  inventorizationCannotOpen: {
    id: 'app.inventory.inventorization.cannotOpen',
  },
  inventorizationDraftNotFound: {
    id: 'app.inventory.inventorization.draftNotFound',
  },
  inventorizationDraftUnavailable: {
    id: 'app.inventory.inventorization.draftUnavailable',
  },
  inventorizationLoadingDraft: {
    id: 'app.inventory.inventorization.loadingDraft',
  },
  inventorizationNewMeter: {
    id: 'app.inventory.inventorization.newMeter',
  },
  llmLocationApiKeyRequired: {
    id: 'app.inventory.llm.locationApiKeyRequired',
  },
  llmPollError: {
    id: 'app.inventory.llm.pollError',
  },
  llmPollLocationApiKeyRequired: {
    id: 'app.inventory.llm.pollLocationApiKeyRequired',
  },
  llmPollTimeout: {
    id: 'app.inventory.llm.pollTimeout',
  },
  llmQueueError: {
    id: 'app.inventory.llm.queueError',
  },
  llmSkipError: {
    id: 'app.inventory.llm.skipError',
  },
  llmSubmitError: {
    id: 'app.inventory.llm.submitError',
  },
  photoWizardExtractionFailed: {
    id: 'app.inventory.photoWizard.extraction.failed',
  },
  reviewActionsBackToReview: {
    id: 'app.inventory.review.actions.backToReview',
  },
  reviewActionsSaveField: {
    id: 'app.inventory.review.actions.saveField',
  },
  scannerValueCodeTitle: {
    id: 'app.inventory.scanner.value.codeTitle',
  },
});
